/* eslint no-debugger: "off" */
import { API } from '@utils/axios'

export async function changePassword (data: TUserProfile.ChangePasswordData) {
  const response = await API.post('/AdminUser/ChangePassword', data)
  return response.data
}
